import emblaCarousel from 'embla-carousel';
import gsap from 'gsap';
import { setupModalVideo } from './video';
import { setupTweenOpacity, addPrevNextBtnHandlers } from './carousel-util';

const setupMouseFollow = (slider) => {
  const bgCard = slider.querySelector('[data-testimonial-bg-card]');

  // fixes occational bug with mouse follow on the bg card
  gsap.set(bgCard, { xPercent: -50, yPercent: -50, x: 0, y: 0 });

  const bgCardXTo = gsap.quickTo(bgCard, 'x', {
    duration: 1.3,
    ease: 'sine'
  });
  const bgCardYTo = gsap.quickTo(bgCard, 'y', {
    duration: 1.3,
    ease: 'sine'
  });
  const bgCardRYTo = gsap.quickTo(bgCard, 'rotationY', {
    duration: 1.3,
    ease: 'sine'
  });
  const bgCardRXTo = gsap.quickTo(bgCard, 'rotationX', {
    duration: 1.3,
    ease: 'sine'
  });

  const onMove = (e) => {
    const winW = window.innerWidth;
    const winH = window.innerHeight;
    bgCardXTo(gsap.utils.mapRange(0, winW, 40, -40, e.clientX));
    bgCardYTo(gsap.utils.mapRange(0, winH, 40, -40, e.clientY));
    bgCardRYTo(gsap.utils.mapRange(0, winW, 50, -50, e.clientX));
    bgCardRXTo(gsap.utils.mapRange(0, winH, 30, -30, e.clientY));
  };

  slider.addEventListener('mousemove', onMove);
};

export const init = (isRM) => {
  const tSliders = document.querySelectorAll('[data-testimonial-slider]');

  tSliders.forEach((slider) => {
    const viewport = slider.querySelector('[data-testimonial-slider-viewport]');
    if (!viewport) return;

    const embla = emblaCarousel(viewport, {
      skipSnaps: true,
      containScroll: 'keepSnaps',
      loop: true
    });

    const slides = slider.querySelectorAll('[data-testimonial-slide]');

    slides[0].setAttribute('aria-hidden', false);

    const { applyTweenOpacity, removeTweenOpacity } = setupTweenOpacity(embla);

    embla.on('select', () => {
      const previous = embla.previousScrollSnap();
      const selected = embla.selectedScrollSnap();
      slides[previous].setAttribute('aria-hidden', true);
      slides[selected].setAttribute('aria-hidden', false);
      const prevButton = slides[previous].querySelector(
        '[data-modal-video-button]'
      );
      if (prevButton) prevButton.disabled = true;
      const selectedButton = slides[selected].querySelector(
        '[data-modal-video-button]'
      );
      if (selectedButton) selectedButton.disabled = false;
    });

    const nextBtn = slider.querySelector('[data-testimonial-next]');
    const prevBtn = slider.querySelector('[data-testimonial-prev]');

    const removePrevNextBtnsClickHandlers = addPrevNextBtnHandlers(
      embla,
      prevBtn,
      nextBtn
    );

    embla
      .on('init', applyTweenOpacity)
      .on('scroll', applyTweenOpacity)
      .on('reInit', applyTweenOpacity)
      .on('destroy', removeTweenOpacity)
      .on('destroy', removePrevNextBtnsClickHandlers);

    if (isRM) return;
    setupMouseFollow(slider);
  });
};
